import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {_openModal} from '../../../../shared/reducers/modals';
import {Column, Dropdown, LoadingSpinner} from '../../../../shared';
import Table from '../../../../shared/components/Table';
import debug from 'debug';
import {gatherData} from '../../../../shared/utils/utils';
import useSWR from 'swr';

const log = debug('circleblack:advisor:analyze:exposure:households:table');

const ExposureHouseholdsTable = ({containerID, onRowClick, rowOnClickDisabled, category, initialType}) => {
  const [type, setType] = React.useState({label: initialType, value: initialType});
  const {data: exposures} = useSWR(containerID && `/containers/${containerID}/exposures`);
  const gatherHouseholds = containerID && gatherData(`/containers/${containerID}/households/exposures`);

  // TODO Filter by type or category?

  const dataManager = {
    gatherData: inputValue => gatherHouseholds({...inputValue, [category]: type.value}),
  };

  const types = React.useMemo(() => {
    if (!exposures) return null;
    let t = ['All Types'];
    if (category !== 'SECTOR') {
      t.push(...(exposures.find(e => e.category === category).types.map(ty => ty.typeName)));
    } else {
      t.push(...(exposures.find(e => ['BOND_SECTOR', 'STOCK_SECTOR'].includes(e.category)).types.map(ty => ty.typeName)));
    }
    return t.map(ty => ({label: ty, value: ty}));
  }, [exposures]);

  React.useEffect(() => {
    if (dataManager.refresh) {
      dataManager.refresh();
    }
  }, [type]);

  log('rendering');

  if (!containerID || !exposures) {
    return <LoadingSpinner/>;
  }

  return <Column height={'100%'}>
    <Dropdown dataPoint={{name: 'type', value: type}}
              placeholder={'Select Type'}
              isClearable={false}
              options={types}
              onChange={(name, value) => setType(value)}/>
    <Table dataManager={dataManager}
           columns={[
             {
               title: 'Household',
               dataPoint: 'displayName',
               type: 'text',
               minWidth: 120,
               isSortable: true,
             },
             {
               title: 'Total Value',
               dataPoint: 'totalValue',
               type: 'currency',
               minWidth: 60,
               isSortable: true,
             },
             category === 'SECTOR' && {
               title: 'Category',
               dataPoint: 'category',
               type: 'text',
               minWidth: 80,
               isSortable: true,
             },
             type.value === 'All Types' && {
               title: category === 'REGION' && 'Region' || category === 'COUNTRY' && 'Country' || 'Type',
               dataPoint: 'typeName',
               type: 'text',
               minWidth: 80,
               isSortable: false,
             },
             {
               title: 'Value',
               dataPoint: 'value',
               type: 'currency',
               minWidth: 80,
               isSortable: true,
             },
             {
               title: 'Percentage',
               dataPoint: 'percent',
               type: 'percentDecimal',
               minWidth: 80,
               isSortable: true,
             },
           ].filter(c => !!c)}
           defaultSort={{
             column: 'percent',
             desc: true,
           }}
           searches={[
             {
               title: 'Household Name',
               name: 'displayName',
               isFuzzy: true,
             },
           ].filter(s => !!s)}
           rowIdentifier={row => `${row.id}-${row.typeName}`}
           rowOnClick={onRowClick}
           rowOnClickDisabled={rowOnClickDisabled}
           height={'200px'}/>
  </Column>;
};

const mapStateToProps = state => ({
  config: state.config,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExposureHouseholdsTable);

ExposureHouseholdsTable.propTypes = {
  openModal: PropTypes.func.isRequired,
  containerID: PropTypes.number.isRequired,
  /**
   * Optional on row click action
   */
  onRowClick: PropTypes.func,
  /**
   * Optional on row click disabled
   */
  rowOnClickDisabled: PropTypes.func,
  category: PropTypes.string.isRequired,
  initialType: PropTypes.string.isRequired,
};
